import React, { Component } from 'react'
import './Aboutus.css'

export default class Aboutus extends Component {
    render() {
        return (
            <div style={{ marginTop: "10%" }}>
                <div className="container">
                    <h2 style={{textAlign:"center"}}>We Work In</h2>
                    <br/>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="workArea">
                                <h5>Big Data Management</h5>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="workArea">
                                <h5>Data Mining & Machine Learning</h5>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="workArea">
                                <h5>Social Data Analytics</h5>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="workArea">
                                <h5>Computer Vision</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
